import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';

export type mitsSortingDirection = 'ASC' | 'DESC';

export interface IMitsSortable {
  name: string;
  title: string;
}

export interface IMitsFilter {
  direction: mitsSortingDirection;
  field: string;
}

@Component({
  selector: 'mits-filter-button',
  templateUrl: './mits-filter-button.component.html',
  styleUrls: ['./mits-filter-button.component.scss'],
})
export class MitsFilterButtonComponent implements AfterViewInit, OnDestroy  {
  /** All sortable fields */
  @Input() sortables: Array<IMitsSortable> = [];
  /** All filterable fields */
  @Input() filterables: Array<IMitsSortable> = [];
  /** Should the button be disabled? */
  @Input() disabled = false;
  /** Default sorted by this sortable (if nothing => "default" gets displayed) */
  @Input() defaultSortable: IMitsSortable;
  /** Default sorted by this sortable (if nothing => "default" gets displayed) */
  @Input() defaultDirection: mitsSortingDirection;
  /** Emits if anything gets changed inside the popover */
  @Output() filtersChanged: EventEmitter<IMitsFilter> =
    new EventEmitter<IMitsFilter>();
  /** Emits if the popover gets closed */
  @Output() filtersClosed: EventEmitter<IMitsFilter> =
    new EventEmitter<IMitsFilter>();

  /** Is the popver currently open? */
  openedPopover = false;
  /** Position of the popover */
  positionPopover: {
    x: number;
    y: number;
  };
  /** Currently selected field */
  selectedField = '';
  /** Currently selected sorting direction */
  sortingDirection: mitsSortingDirection;

  /** Element of the popover backdrop */
  @ViewChild('mitsFilterPopoverBackdrop')
  popoverBackdropElement: ElementRef<HTMLSpanElement>;
  /** Element of the popover wrapper */
  @ViewChild('mitsFilterPopoverWrapper')
  popoverWrapperElement: ElementRef<HTMLSpanElement>;

  ngAfterViewInit(): void {
    const newParent = document.getElementsByTagName('html')[0];
    newParent.appendChild(this.popoverBackdropElement.nativeElement);
    if (this.defaultDirection) this.sortingDirection = this.defaultDirection;
    if (this.defaultSortable) this.selectedField = this.defaultSortable.name;
  }

  ngOnDestroy(): void {
    this.popoverBackdropElement.nativeElement.remove();
  }

  /**
   * Gets executed if Field-Selection gets changed
   */
  changedField() {
    if (this.selectedField === '') {
      this.sortingDirection = null;
    } else {
      this.sortingDirection = 'ASC';
    }
    this.emitChange();
  }

  /**
   * Gets triggert if the user clicks on the filter-button
   * @param event click-event
   */
  clickFilterButton(ev: any): void {
    if (this.disabled) return;
    if (ev && !this.openedPopover) {
      this.positionPopover = {
        x: ev.pageX - 266,
        y: ev.pageY - 20,
      };
    }
    this.popoverWrapperElement.nativeElement.style.left =
      this.positionPopover.x.toString() + 'px';
    this.popoverWrapperElement.nativeElement.style.top =
      this.positionPopover.y.toString() + 'px';
    this.openedPopover = !this.openedPopover;
  }

  /**
   * If backdrop gets clicked
   */
  clickedBackdrop(): void {
    this.openedPopover = false;
    this.emitClose();
  }

  /**
   * Changes the sortig direction. (Toggle between both)
   */
  changeSortingDirection(): void {
    if (this.selectedField === '') {
      this.sortingDirection = null;
    } else {
      this.sortingDirection = this.sortingDirection === 'ASC' ? 'DESC' : 'ASC';
    }
    this.emitChange();
  }

  /**
   * Emits the change of an attribute inside the filters-popover including the saved filters
   */
  private emitChange(): void {
    const currFilters: IMitsFilter = {
      direction: this.sortingDirection,
      field: this.selectedField,
    };
    this.filtersChanged.emit(currFilters);
  }

  /**
   * Emits the closing of the filters-popover including the saved filters
   */
  private emitClose(): void {
    const currFilters: IMitsFilter = {
      direction: this.sortingDirection,
      field: this.selectedField,
    };
    this.filtersClosed.emit(currFilters);
  }
}
